

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		new AboutModal( ) ;
		// new ReadComic( ) ;
		//new Campaign( ) ;
		new Character( ) ;
		//new Movie( ) ;


		//


		var count = 2 ;
		var _onLoadComplete = function( )
		{
			count -- ;
			if( count )	return ;

			Call.add( this , { time:0.2 } , { onComplete:function( )
				{
					new Meter( ) ;
				} } ) ;
		}

		// $.ajax( "https://s3-ap-northeast-1.amazonaws.com/monster-strike-promotion/taizai_collabo/tweet_count.json" , {
		// $.ajax( "./assets/7-taizai/json/tweet.json" , {
		// 	success:function( data )
		// 	{
		// 		// data = JSON.parse( data ) ; //上記のs3のサーバーから引っ張ってくるときには必要
		// 		Main.tweet_count = data.counts[0].count ;

		// 		_onLoadComplete( ) ;
		// 	}
		// } ) ;

		$.ajax( "./assets/7-taizai/json/meter.json" , {
			success:function( data )
			{
				Main.meter_count = data.count ;
				// console.log( Main.meter_count ) ;

				_onLoadComplete( ) ;
			}
		} ) ;

		Utils.Image.load.object( Meter.img , _onLoadComplete , false , true ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var AboutModal = function( )
	{
		var _this = this ;
		var i ;

		var _btn_about = document.getElementsByClassName( "open-about" )[0] ;

		var _modal = document.getElementById( "about" ) ;
		_modal.style.opacity = 0 ;
		_modal.style.display = "none" ;

		var _bg_layer = _modal.getElementsByClassName( "bg-layer" )[0] ;
		var _btn_close = _modal.getElementsByClassName( "btn-close" )[0] ;

		var _close = function( )
		{
			document.body.style.overflow = "" ;
			Tween.add( _modal.style , { opacity:0 , time:0.15 , transition:"linear" } , { onComplete:function(){_modal.style.display = "none" ;} } ) ;
		}
		var _open = function( )
		{
			document.body.style.overflow = "hidden" ;
			Tween.add( _modal.style , { opacity:1 , time:0.15 , transition:"linear" } ,
				{ onStart:function( )
					{
						_modal.style.display = "block" ;
						// if( !is_slick_init )
						// {
						// 	_movie_list_ul_obj.slick( slickInitObj ) ;
						// 	is_slick_init = true ;
						// }
					} } ) ;
		}

		_btn_about.addEventListener( "click" , _open ) ;

		_bg_layer.addEventListener( "click" , _close ) ;
		_btn_close.addEventListener( "click" , _close ) ;


		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		// var _movie_list_ul = _modal.getElementsByClassName( "movie-list" )[0] ;
		// var slickInitObj =
		// {
		// 	arrows:true ,
		// 	infinite:true ,
		// 	slidesToShow: 1 ,
		// 	slidesToScroll: 1 ,
		// 	initialSlide:0 ,
		// 	dots: true ,
		// 	autoplay: false ,
		// 	autoplaySpeed: 5000 ,
		// 	swipeToSlide:true ,
		// 	cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
		// 	speed:350
		// };
		// var _movie_list_ul_obj = $( _movie_list_ul ) ;
		// var is_slick_init = false ;
		// _movie_list_ul_obj.slick( slickInitObj ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var ReadComic = function( )
	{
		var _this = this ;
		var i ;

		var _btn_about = document.getElementsByClassName( "open-read-comic" )[0] ;

		var _modal = document.getElementById( "read-comic" ) ;
		_modal.style.opacity = 0 ;
		_modal.style.display = "none" ;

		var _bg_layer = _modal.getElementsByClassName( "bg-layer" )[0] ;
		var _btn_close = _modal.getElementsByClassName( "btn-close" )[0] ;

		var _close = function( )
		{
			document.body.style.overflow = "" ;
			Tween.add( _modal.style , { opacity:0 , time:0.15 , transition:"linear" } , { onComplete:function(){_modal.style.display = "none" ;} } ) ;
		}
		var _open = function( )
		{
			document.body.style.overflow = "hidden" ;
			Tween.add( _modal.style , { opacity:1 , time:0.15 , transition:"linear" } ,
				{ onStart:function( )
					{
						_modal.style.display = "block" ;
						if( !is_slick_init )
						{
							_movie_list_ul_obj.slick( slickInitObj ) ;
							is_slick_init = true ;
						}
					} } ) ;
		}

		_btn_about.addEventListener( "click" , _open ) ;

		_bg_layer.addEventListener( "click" , _close ) ;
		_btn_close.addEventListener( "click" , _close ) ;


		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		var _movie_list_ul = _modal.getElementsByClassName( "read-comic-list" )[0] ;
		var slickInitObj =
		{
			arrows:true ,
			infinite:false ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:65 ,
			dots: false ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
		};
		var _movie_list_ul_obj = $( _movie_list_ul ) ;
		var is_slick_init = false ;
		// _movie_list_ul_obj.slick( slickInitObj ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var Campaign = function( )
	{
		var _this = this , i ;

		var _root = document.getElementById( "campaign" ) ;

		var _treasure_1_4 = document.getElementById( "treasure1-4" ) ;
		var _treasure_detail = _treasure_1_4.getElementsByClassName( "treasure-detail" )[0] ;
		var _treasure_1_4_ul = _treasure_1_4.getElementsByTagName( "ul" )[0] ;

		var slickInitObj =
		{
			arrows:true,
			infinite: true ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:0 ,
			dots: true ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
		};
		var _treasure_1_4_obj = $( _treasure_1_4_ul ) ;
		_treasure_1_4_obj.slick( slickInitObj ) ;

		_treasure_1_4_obj.on( 'beforeChange' , function( event, slick, currentSlide, nextSlide ){

			_treasure_detail.className = "treasure-detail index-" + ( nextSlide + 1 ) ;

		});


		var _treasure_anchor_a = _root.getElementsByClassName( "treasure-anchor" )[0].getElementsByTagName("a") ;
		var _onA = function( evt )
		{
			switch( evt.currentTarget )
			{
				case _treasure_anchor_a[0] :
					_treasure_1_4_obj.slick( "slickGoTo" , 0 ) ;
					break ;
				case _treasure_anchor_a[1] :
					_treasure_1_4_obj.slick( "slickGoTo" , 1 ) ;
					break ;
				case _treasure_anchor_a[2] :
					_treasure_1_4_obj.slick( "slickGoTo" , 2 ) ;
					break ;
				case _treasure_anchor_a[3] :
					_treasure_1_4_obj.slick( "slickGoTo" , 3 ) ;
					break ;
			}
		}
		_treasure_anchor_a[0].addEventListener( "click" , _onA ) ;
		_treasure_anchor_a[1].addEventListener( "click" , _onA ) ;
		_treasure_anchor_a[2].addEventListener( "click" , _onA ) ;
		_treasure_anchor_a[3].addEventListener( "click" , _onA ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	var Meter = function( )
	{
		var _this = this , i ;

		var _root = document.getElementById("meter") ;
		var _meter = _root.getElementsByClassName("area-canvas")[0] ;


		//



		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-


		var _stage = new PIXI.Container( ) ;
		var _renderer = PIXI.autoDetectRenderer( 640 , 578 , { transparent:false , backgroundColor:0x8a0a0a } ) ;
		_renderer.plugins.interaction.autoPreventDefault = false ;
		_renderer.view.style.position = "absolute" ;
		_renderer.view.style.left = _renderer.view.style.top = 0 ;
		_renderer.view.style.width = "100%" ;
		_renderer.view.style.height = "auto" ;

		_meter.insertBefore( _renderer.view , _meter.firstChid ) ;

		//

		var _bg = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.bg) ) ;

		var _hoke_body = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.hoke_body) ) ;
		var _hoke_head_set = new PIXI.Container( ) ;
		var _hoke_head = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.hoke_head) ) ;
		var _hoke_mouth = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.hoke_mouth) ) ;
		_hoke_head_set.addChild( _hoke_mouth ) ;
		_hoke_head_set.addChild( _hoke_head ) ;

		var _table = new PIXI.extras.TilingSprite( PIXI.Texture.fromCanvas(Meter.img.table) , 640 , 80 ) ;

		var _con_dish = Meter.con_dish = new PIXI.Container( ) ;
		var _con_zanpan = Meter.con_zanpan = new PIXI.Container( ) ;

		var _con_result = new PIXI.Container( ) ;
		var _con_result_bar = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.result_bar) ) ;
		var _con_result_treasure = new PIXI.Sprite( PIXI.Texture.fromCanvas(Meter.img.result_25) ) ;
		_con_result.pivot.x = _con_result_bar.width ;
		_con_result.x = _renderer.width + _con_result_bar.width + 10 ;
		_con_result.y = 210 ;
		_con_result_treasure.x = 47 ;
		_con_result_treasure.y = 26 ;
		// _con_result_treasure.transform = new PIXI.Transform( ) ;
		// _con_result_treasure.skew.x = -0.1 ;
		// console.log( _con_result_treasure.transform ) ;


		_hoke_body.y = _hoke_body.defY = 300 ;
		_hoke_head_set.x = _hoke_head_set.defX = 69 + 85 ;
		_hoke_head_set.y = _hoke_head_set.defY =320 ;
		_hoke_head_set.pivot.x = 85 ;
		_hoke_mouth.x = 65 ;
		_hoke_mouth.y = _hoke_mouth.defY = 167 ;

		_table.y = _renderer.height - _table.height ;

		_con_dish.y = _renderer.height - 130 ;
		_con_zanpan.y = _renderer.height - 130 ;



		_stage.addChild( _bg ) ;

		_stage.addChild( _hoke_body ) ;
		_stage.addChild( _table ) ;
		_stage.addChild( _con_dish ) ;
		_stage.addChild( _hoke_head_set ) ;
		_stage.addChild( _con_zanpan ) ;

		_con_result.addChild( _con_result_bar ) ;
		_con_result.addChild( _con_result_treasure ) ;
		_stage.addChild( _con_result ) ;

		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		var _isEating = false ;

		var _kubifurifuri = function( )
		{
			// if( !_isEating )	return ;

			// _isEating = false ;

			Tween.remove( _hoke_head_set ) ;
			Tween.remove( _hoke_mouth ) ;
			Tween.add( _hoke_mouth , { y:_hoke_mouth.defY , time:0.1 , transition:"easeOutSine" } ) ;
			Tween.add( _hoke_head_set , { rotation:2/180*Math.PI , time:0.5 , transition:"easeInOutSine" } ) ;
			Tween.add( _hoke_head_set , { rotation:0 , time:0.5 , transition:"easeInOutSine" , delay:0.5 } ,
				{ onComplete:_kubifurifuri } ) ;
		}
		_kubifurifuri( ) ;


		var _pakupaku = function( )
		{
			// if( _isEating )	return ;

			// _isEating = true ;

			Tween.remove( _hoke_head_set ) ;
			Tween.remove( _hoke_mouth ) ;
			Tween.add( _hoke_mouth , { y:_hoke_mouth.defY-15 , time:0.1 , transition:"easeInOutSine" } ) ;
			Tween.add( _hoke_mouth , { y:_hoke_mouth.defY , time:0.1 , transition:"easeInOutSine" , delay:0.1 } ) ;
			Tween.add( _hoke_head_set , { rotation:4/180*Math.PI , time:0.1 , transition:"easeInOutSine" } ) ;
			Tween.add( _hoke_head_set , { rotation:0 , time:0.1 , transition:"easeInOutSine" , delay:0.1 } ,
				{ onComplete:_pakupaku } ) ;
		}


		var _step = function( )
		{
			Tween.remove( _hoke_head_set ) ;
			Tween.remove( _hoke_mouth ) ;
			Tween.add( _hoke_mouth , { y:_hoke_mouth.defY , time:0.1 , transition:"easeOutSine" } ) ;


			Tween.add( _hoke_body , { y:_hoke_body.defY+10 , x:-60 , time:0.1 , transition:"linear" } ) ;
			Tween.add( _hoke_body , { y:_hoke_body.defY-20 , time:0.1 , transition:"easeOutCubic" , delay:0.1 } ) ;
			Tween.add( _hoke_body , { y:_hoke_body.defY , time:0.1 , transition:"easeInCubic" , delay:0.1+0.1 } ) ;
			Tween.add( _hoke_body , { x:-30 , time:0.2 , transition:"easeOutQuad" , delay:0.1 } ) ;

			Tween.add( _hoke_head_set , { y:_hoke_head_set.defY+10 , x:_hoke_head_set.defX-60 , time:0.1 , transition:"linear" } ) ;
			Tween.add( _hoke_head_set , { y:_hoke_head_set.defY-20 , time:0.1 , transition:"easeOutCubic" , delay:0.1 } ) ;
			Tween.add( _hoke_head_set , { y:_hoke_head_set.defY , time:0.1 , transition:"easeInCubic" , delay:0.1+0.1 } ) ;
			Tween.add( _hoke_head_set , { x:_hoke_head_set.defX-30 , time:0.2 , transition:"easeOutQuad" , delay:0.1 } ) ;


			Tween.add( _hoke_body , { y:_hoke_body.defY-20 , time:0.1 , transition:"easeOutCubic" , delay:0.3 } ) ;
			Tween.add( _hoke_body , { y:_hoke_body.defY , time:0.1 , transition:"easeInCubic" , delay:0.3+0.1 } ) ;
			Tween.add( _hoke_body , { x:0 , time:0.2 , transition:"easeOutQuad" , delay:0.3 } ) ;

			Tween.add( _hoke_head_set , { y:_hoke_head_set.defY-20 , time:0.1 , transition:"easeOutCubic" , delay:0.3 } ) ;
			Tween.add( _hoke_head_set , { y:_hoke_head_set.defY , time:0.1 , transition:"easeInCubic" , delay:0.3+0.1 } ) ;
			Tween.add( _hoke_head_set , { x:_hoke_head_set.defX , time:0.2 , transition:"easeOutQuad" , delay:0.3 } ) ;


			Tween.add( _hoke_head_set , { rotation:4/180*Math.PI , time:0.1 , transition:"easeOutSine" } ) ;
			Tween.add( _hoke_head_set , { rotation:0 , time:0.2 , transition:"easeOutSine" , delay:0.1 } ) ;

			// Tween.add( _hoke_head_set , { rotation:4/180*Math.PI , time:0.1 , transition:"easeInOutSine" } ) ;
			// Tween.add( _hoke_head_set , { rotation:0 , time:0.1 , transition:"easeInOutSine" , delay:0.1 } ,
				// { onComplete:_pakupaku } ) ;
		}

		//

		var _percent = ( (  Main.meter_count ) / 2000000 ) * 100 ;

		// _percent = 100 ;
		// console.log( _percent) ;
		// if( location.search )
		// {
		// 	_percent = location.search.replace( /\?/gi , "" ) ;
		// }

		if( _percent < 1 )
		{
			_percent = 1 ;
		}
		else if( _percent > 100 )
		{
			_percent = 100 ;
		}

		//

		var _eatCount = Math.floor( _percent/(100/(4*8)) ) ;
		// console.log( _eatCount ) ;
		if( _eatCount < 2 )
		{
			_eatCount = 2 ;
		}
		// _eatCount -= 2 ;
		// console.log( _eatCount ) ;


		var _meter_bar = _root.getElementsByClassName( "bar" )[0] ;
		_meter_bar.style.width = "0%" ;
		_meter_bar.percent = 0 ;

		var _treasure_6_complete = _root.getElementsByClassName( "treasure-6-complete" )[0] ;
		_treasure_6_complete.style.width = "0%" ;

		var _gage_percent = _root.getElementsByClassName( "gage-percent" )[0] ;

		var _treasure_6_complete_mark = _root.getElementsByClassName( "treasure-6-complete-mark" )[0].getElementsByTagName( "li" ) ;

		//

		var _treasure_opend = [ false , false , false , false ] ;

		var _slidePos = { x:0 } ;

		_slidePos.update = function( )
		{
			_table.tilePosition.x = _slidePos.x ;
			_con_dish.x = _slidePos.x ;
			_con_zanpan.x = _slidePos.x ;
			_bg.x = _slidePos.x * 0.1 ;
		}

		var _progressLength = Math.ceil( _percent / 12.5 ) ;
		var _eatLength = 0 ;

		var _eat = Meter.eat = function( gotoNext )
		{
			if( _eatLength >= Meter.Zanpan.instance.length || _eatLength >= _progressLength || !gotoNext )
			{
				_kubifurifuri( ) ;
				// Call.add( this , { time:0.1 } , { onComplete:_kubifurifuri } ) ;
				return ;
			}


			_step( ) ;
			Tween.add( _slidePos , { x:-120-180*_eatLength , time:0.4 , transition:"easeInOutQuad" , delay:0 } , { onUpdate:_slidePos.update } ) ;

			Call.add( this , { time:0.5 } , { onComplete:function( )
				{
					_pakupaku( ) ;

					// var eatCount = 2.5*5*(_eatLength+1) - 2.5*5*(_eatLength)
					if( _eatCount > 4 )
					{
						Meter.Zanpan.instance[_eatLength].ate( 5 ) ;
						_eatCount -= 4 ;
					}
					else
					{
						Meter.Zanpan.instance[_eatLength].ate( _eatCount+1 ) ;
						_eatCount = 0 ;
					}

					_eatLength ++ ;

					var settingPercent = 2.5*5*_eatLength ;
					if( settingPercent > _percent )
					{
						settingPercent = _percent ;
					}

					Tween.add( _meter_bar , { percent:settingPercent , time:0.2*5 , transition:"easeInOutSine" } ,
						{ onUpdate:function( )
							{
								_meter_bar.style.width = _meter_bar.percent+"%" ;
								_gage_percent.innerHTML = Math.floor( _meter_bar.percent ) ;

								if( !_treasure_opend[0] && _meter_bar.percent >= 25 )
								{
									_treasure_opend[0] = true ;
									Tween.add( _treasure_6_complete.style , { width:"25%" , time:0.4 , transition:"easeInOutCubic" } ) ;
									_treasure_6_complete_mark[0].className = "complete" ;

									Tween.add( _con_result , { x:_renderer.width , time:0.4 , transition:"linear" } ) ;
									Tween.add( _con_result_treasure.skew , { x:0.3 , time:0.15 , transition:"easeOutQuad" , delay:0.4 } ) ;
									Tween.add( _con_result_treasure.skew , { x:-0.1 , time:0.3 , transition:"easeInOutQuad" , delay:0.4+0.15 } ) ;
									Tween.add( _con_result_treasure.skew , { x:0.05 , time:0.3 , transition:"easeInOutQuad" , delay:0.4+0.15+0.3 } ) ;
									Tween.add( _con_result_treasure.skew , { x:0 , time:0.15 , transition:"easeInQuad" , delay:0.4+0.15+0.6 } ) ;
								}
								else if( !_treasure_opend[1] && _meter_bar.percent >= 50 )
								{
									_treasure_opend[1] = true ;
									Tween.add( _treasure_6_complete.style , { width:"50%" , time:0.4 , transition:"easeInOutCubic" } ) ;
									_treasure_6_complete_mark[1].className = "complete" ;

									Tween.add( _con_result , { x:_renderer.width+_con_result_bar.width+10 , time:0.4 , transition:"easeInQuad" } ,
										 { onComplete:function( )
										 	{
										 		_con_result_treasure.texture = PIXI.Texture.fromCanvas( Meter.img.result_50 ) ;
										 		Tween.add( _con_result , { x:_renderer.width , time:0.4 , transition:"linear" , delay:0.1 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.3 , time:0.15 , transition:"easeOutQuad" , delay:0.5 } ) ;
												Tween.add( _con_result_treasure.skew , { x:-0.1 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.05 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15+0.3 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0 , time:0.15 , transition:"easeInQuad" , delay:0.5+0.15+0.6 } ) ;
										 	}
										 }) ;
								}
								else if( !_treasure_opend[2] && _meter_bar.percent >= 75 )
								{
									_treasure_opend[2] = true ;
									Tween.add( _treasure_6_complete.style , { width:"75%" , time:0.4 , transition:"easeInOutCubic" } ) ;
									_treasure_6_complete_mark[2].className = "complete" ;

									Tween.add( _con_result , { x:_renderer.width+_con_result_bar.width+10 , time:0.4 , transition:"easeInQuad" } ,
										 { onComplete:function( )
										 	{
										 		_con_result_treasure.texture = PIXI.Texture.fromCanvas( Meter.img.result_75 ) ;
										 		Tween.add( _con_result , { x:_renderer.width , time:0.4 , transition:"linear" , delay:0.1 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.3 , time:0.15 , transition:"easeOutQuad" , delay:0.5 } ) ;
												Tween.add( _con_result_treasure.skew , { x:-0.1 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.05 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15+0.3 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0 , time:0.15 , transition:"easeInQuad" , delay:0.5+0.15+0.6 } ) ;
										 	}
										 }) ;
								}
								else if( !_treasure_opend[3] && _meter_bar.percent >= 100 )
								{
									_treasure_opend[3] = true ;
									Tween.add( _treasure_6_complete.style , { width:"100%" , time:0.4 , transition:"easeInOutCubic" } ) ;
									_treasure_6_complete_mark[3].className = "complete" ;

									Tween.add( _con_result , { x:_renderer.width+_con_result_bar.width+10 , time:0.4 , transition:"easeInQuad" } ,
										 { onComplete:function( )
										 	{
										 		_con_result_treasure.texture = PIXI.Texture.fromCanvas( Meter.img.result_100 ) ;
										 		Tween.add( _con_result , { x:_renderer.width , time:0.4 , transition:"linear" , delay:0.1 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.3 , time:0.15 , transition:"easeOutQuad" , delay:0.5 } ) ;
												Tween.add( _con_result_treasure.skew , { x:-0.1 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0.05 , time:0.3 , transition:"easeInOutQuad" , delay:0.5+0.15+0.3 } ) ;
												Tween.add( _con_result_treasure.skew , { x:0 , time:0.15 , transition:"easeInQuad" , delay:0.5+0.15+0.6 } ) ;
										 	}
										 }) ;
								}
							}
						} ) ;
				} } ) ;
		}
		var _start = function( )
		{
			new Meter.Zanpan( 320 , 0 ) ;
			new Meter.Zanpan( 320+180 , 0.2 ) ;
			new Meter.Zanpan( 320+180*2 , 0.4 ) ;
			new Meter.Zanpan( 320+180*3 , -1 ) ;
			new Meter.Zanpan( 320+180*4 , -1 ) ;
			new Meter.Zanpan( 320+180*5 , -1 ) ;
			new Meter.Zanpan( 320+180*6 , -1 ) ;
			new Meter.Zanpan( 320+180*7 , -1 ) ;

			// _eat( ) ;
			Call.add( this , { time:0.5 } , { onComplete:_eat , onCompleteParams:[true] } ) ;
		}
		// Call.add( this , { time:0.5 } , { onComplete:_start } ) ;

		ScrollEnterEvent.add( _meter , { func:_start , marginScale:0.2 , timeout:0.1 } ) ;

		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-


		var _update = function( )
		{
			window.requestAnimationFrame( _update ) ;

			_renderer.render( _stage ) ;
		}
		window.requestAnimationFrame( _update ) ;


	}
	Meter.Zanpan = function( x , delay )
	{
		Meter.Zanpan.instance.push( this ) ;

		var _this = this , i ;

		var _dish = new PIXI.Sprite( PIXI.Texture.fromCanvas( Meter.img.dish ) ) ;
		var _zanpan = new PIXI.Sprite( PIXI.Texture.fromCanvas( Meter.img.zanpan_4 ) ) ;
		var _tex_arr =
		[
			PIXI.Texture.fromCanvas( Meter.img.zanpan_1 ) ,
			PIXI.Texture.fromCanvas( Meter.img.zanpan_2 ) ,
			PIXI.Texture.fromCanvas( Meter.img.zanpan_3 ) ,
			PIXI.Texture.fromCanvas( Meter.img.zanpan_4 )
		]
		var _tex_arr_index = 4 ;

		_dish.anchor.x = 0.5 ;
		_zanpan.anchor.x = 0.5 ;
		_dish.pivot.y = 100 ;

		_dish.x = x ;
		_zanpan.x = x ;

		if( delay >= 0 )
		{
			_dish.y = 100-30 ;
			_dish.alpha = 0 ;
			_zanpan.y = -30 ;
			_zanpan.alpha = 0 ;
			Tween.add( _dish , { alpha:1 , time:0.2 , transition:"linear" , delay:0.1+delay } ) ;
			Tween.add( _dish , { y:100 , time:0.2 , transition:"easeInCubic" , delay:0.2+delay } ) ;
			Tween.add( _zanpan , { alpha:1 , time:0.2 , transition:"linear" , delay:0.2+delay } ) ;
			Tween.add( _zanpan , { y:0 , time:0.2 , transition:"easeInCubic" , delay:0.3+delay } ) ;
		}
		else
		{
			_dish.y = 100 ;
		}


		Meter.con_dish.addChild( _dish ) ;
		Meter.con_zanpan.addChild( _zanpan ) ;

		var _eatCount = 0 ;


		var _ate = this.ate = function( eatCount )
		{
			if( eatCount != undefined )	_eatCount = eatCount ;

			if( _tex_arr_index < 0 || _eatCount == 0 )
			{
				Tween.add( _dish , { rotation:0 , time:0.2 , transition:"easeOutBack" } ) ;
				Meter.eat( _tex_arr_index < 0 ) ;
				return ;
			}

			_eatCount -- ;
			_tex_arr_index -- ;

			Tween.add( _dish , { rotation:3/180*Math.PI*(_tex_arr_index%2?1:-1) , time:0.15 , transition:"easeOutCubic" } ) ;

			Tween.add( _zanpan , { y:-4 , time:0.1 , transition:"easeOutQuad" , delay:0 } ) ;
			Tween.add( _zanpan , { y:0 , time:0.1 , transition:"easeInQuad" , delay:0.1 } ,
				{ onStart:function( )
					{
						// console.log( _tex_arr ) ;
						if( _tex_arr_index >= 0 )
						{
							_zanpan.texture = _tex_arr[_tex_arr_index] ;
						}
						else
						{
							_zanpan.visible = false ;
						}
					} ,
					onComplete:_ate } ) ;
		}
		// Call.add( this , { time:1 } , { onComplete:_heru } ) ;
	}
	Meter.Zanpan.instance = [] ;
	Meter.img =
	{
		bg:"./assets/7-taizai/img/sp/meter/canvas/bg.jpg" ,
		dish:"./assets/7-taizai/img/sp/meter/canvas/dish.png" ,
		hoke_head:"./assets/7-taizai/img/sp/meter/canvas/hoke_head.png" ,
		hoke_mouth:"./assets/7-taizai/img/sp/meter/canvas/hoke_mouth.png" ,
		hoke_body:"./assets/7-taizai/img/sp/meter/canvas/hoke_body.png" ,
		table:"./assets/7-taizai/img/sp/meter/canvas/table.png" ,
		zanpan_1:"./assets/7-taizai/img/sp/meter/canvas/zanpan_1.png" ,
		zanpan_2:"./assets/7-taizai/img/sp/meter/canvas/zanpan_2.png" ,
		zanpan_3:"./assets/7-taizai/img/sp/meter/canvas/zanpan_3.png" ,
		zanpan_4:"./assets/7-taizai/img/sp/meter/canvas/zanpan_4.png" ,

		result_25:"./assets/7-taizai/img/sp/meter/canvas/result_25.png" ,
		result_50:"./assets/7-taizai/img/sp/meter/canvas/result_50.png" ,
		result_75:"./assets/7-taizai/img/sp/meter/canvas/result_75.png" ,
		result_100:"./assets/7-taizai/img/sp/meter/canvas/result_100.png" ,
		result_bar:"./assets/7-taizai/img/sp/meter/canvas/result_bar.png"
	}


//------------------------------------------------------------------------------------------------------------------------------


	var Character = function( )
	{
		var _this = this , i ;
		var _root = document.getElementById( "character" ) ;

		var _char_thumb_list = _root.getElementsByClassName( "char-thumb-list" )[0] ;
		var _char_detail = _root.getElementsByClassName( "char-detail" )[0] ;
		var _char_txt_movie = _root.getElementsByClassName( "char-txt-movie" )[0] ;


		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-


		var _char_thumb_button = _char_thumb_list.getElementsByTagName( "button" ) ;
		var _onBtn = function( evt )
		{
			// console.log( evt.currentTarget.index ) ;
			_char_detail_obj.slick( "slickGoTo" , evt.currentTarget.index ) ;
		}
		var _char_index_arr = [ 1 , 4 , 6 , 8 ,
														10 , 12 , 14 , 16 ,
														18 , 20 , 22 ] ;
		for( i = 0 ; i < _char_thumb_button.length ; i++ )
		{
			_char_thumb_button[i].index = _char_index_arr[i] ;
			_char_thumb_button[i].addEventListener( "click" , _onBtn ) ;
		}

		var slickInitObj =
		{
			arrows:true,
			infinite: true ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:0 ,
			dots: false ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
	  };

		var _char_thumb_list_obj = $( _char_thumb_list ) ;
		_char_thumb_list_obj.slick( slickInitObj ) ;
		_char_thumb_list.def = { className:_char_thumb_list.className } ;
		_char_thumb_list.className = _char_thumb_list.def.className + " index-1" ;

		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		var _wrap_char_thumb = _root.getElementsByClassName( "wrap-char-thumb" )[0] ;

		var slickInitObj =
		{
			arrows:true,
			infinite: true ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:1 ,
			dots: false ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
	  };

		var _char_detail_obj = $( _char_detail ) ;
		_char_detail_obj.slick( slickInitObj ) ;
		_char_detail.def = { className:_char_detail.className } ;
		_char_detail.className = _char_detail.def.className + " prev-shinkamae next-kamika" ;

		_char_detail_obj.on( 'beforeChange' , function( event, slick, currentSlide, nextSlide ){

			_wrap_char_thumb.className = "wrap-char-thumb index-" + ( nextSlide + 1 ) ;

			// キャラサムネールとの連動
			nextSlide = nextSlide%24 ;
			switch( nextSlide )
			{
				case 0 :
				case 1 :
				case 2 :
				case 3 :
				case 4 :
				case 5 :
				case 6 :
				case 7 :
				case 8 :
					_char_thumb_list_obj.slick( "slickGoTo" , currentSlide==23?3:0 ) ;
					break ;

				case 9 :
				case 10 :
				case 11 :
				case 12 :
				case 13 :
				case 14 :
				case 15 :
				case 16 :
					_char_thumb_list_obj.slick( "slickGoTo" , 1 ) ;
					break ;

				case 17 :
				case 18 :
				case 19 :
				case 20 :
				case 21 :
				case 22 :
				case 23 :
					_char_thumb_list_obj.slick( "slickGoTo" , currentSlide==0?-1:2 ) ;
					break ;
			}

			// キャラ詳細情報との連動
			switch( nextSlide )
			{
				case 0 :
				case 1 :
				case 2 :
					_char_txt_movie_obj.slick( "slickGoTo" , currentSlide==23?11:0 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-1" ;
					break ;
				case 3 :
				case 4 :
					_char_txt_movie_obj.slick( "slickGoTo" , 1 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-2" ;
					break ;
				case 5 :
				case 6 :
					_char_txt_movie_obj.slick( "slickGoTo" , 2 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-3" ;
					break ;
				case 7 :
				case 8 :
					_char_txt_movie_obj.slick( "slickGoTo" , 3 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-4" ;
					break ;

				case 9 :
				case 10 :
					_char_txt_movie_obj.slick( "slickGoTo" , 4 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-5" ;
					break ;
				case 11 :
				case 12 :
					_char_txt_movie_obj.slick( "slickGoTo" , 5 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-6" ;
					break ;
				case 13 :
				case 14 :
					_char_txt_movie_obj.slick( "slickGoTo" , 6 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-7" ;
					break ;
				case 15 :
				case 16 :
					_char_txt_movie_obj.slick( "slickGoTo" , 7 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-8" ;
					break ;

				case 17 :
				case 18 :
					_char_txt_movie_obj.slick( "slickGoTo" , 8 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-9" ;
					break ;
				case 19 :
				case 20 :
					_char_txt_movie_obj.slick( "slickGoTo" , 9 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-10" ;
					break ;
				case 21 :
				case 22 :
				case 23 :
					_char_txt_movie_obj.slick( "slickGoTo" , currentSlide==0?-1:10 ) ;
					_char_thumb_list.className = _char_thumb_list.def.className + " index-11" ;
					break ;
			}

			// キャラの横遷移ボタンとの連携
			switch( nextSlide )
			{

				case 4 :
				case 6 :
				case 8 :
				case 10 :
				case 12 :
				case 14 :
				case 16 :
				case 18 :
				case 20 :
					_char_detail.className = _char_detail.def.className + " prev-shinkamae next-char" ;
					break ;

				case 1 :
					_char_detail.className = _char_detail.def.className + " prev-shinkamae next-kamika" ;
					break ;

				case 2 :
					_char_detail.className = _char_detail.def.className + " prev-shinka next-char" ;
					break ;

				case 0 :
				case 3 :
				case 5 :
				case 7 :
				case 9 :
				case 11 :
				case 13 :
				case 15 :
				case 17 :
				case 19 :
				case 21 :
					_char_detail.className = _char_detail.def.className + " prev-char next-shinka" ;
					break ;

				case 22 :
					_char_detail.className = _char_detail.def.className + " prev-shinkamae next-shinka" ;
					break ;

				case 23 :
					_char_detail.className = _char_detail.def.className + " prev-shinka next-char" ;
					break ;
			}

		});


		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-


		var slickInitObj =
		{
			arrows:false,
			infinite: true ,
			slidesToShow: 1 ,
			slidesToScroll: 1 ,
			initialSlide:0 ,
			dots: false ,
			autoplay: false ,
			autoplaySpeed: 5000 ,
			swipeToSlide:true ,
			touchMove:false,
			swipe:false,
			cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
			speed:350
	  };


		var _char_txt_movie_obj = $( _char_txt_movie ) ;
		_char_txt_movie_obj.slick( slickInitObj ) ;


	}


//------------------------------------------------------------------------------------------------------------------------------


var Movie = function( )
{
	var _this = this , i ;

	var _root = document.getElementById( "movie" ) ;

	var _movie_list = _root.getElementsByClassName( "movie-list" )[0] ;


	var slickInitObj =
	{
		arrows:true,
		infinite: true ,
		slidesToShow: 1 ,
		slidesToScroll: 1 ,
		initialSlide:0 ,
		dots: true ,
		autoplay: false ,
		autoplaySpeed: 5000 ,
		swipeToSlide:true ,
		cssEase:"cubic-bezier(0.215, 0.610, 0.355, 1.000)" ,
		speed:350
	};

	var _movie_list_obj = $( _movie_list ) ;
	_movie_list_obj.slick( slickInitObj ) ;
}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

